export function OrganizationSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51爆料网',
    url: 'http://921xwm.cn/',
    description: '51爆料网每日爆料黑料吃瓜，提供51今日大瓜及每日大赛往期内容，独家八卦、往期精华免费回顾',
    sameAs: [
      'http://921xwm.cn/org/51baoliao',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-5151',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

export function WebSiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51爆料网',
    url: 'http://921xwm.cn/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://921xwm.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

export function WebPageSchema({ pageUrl, pageName, description, datePublished }: {
  pageUrl: string;
  pageName: string;
  description: string;
  datePublished?: string;
}) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: pageUrl,
    name: pageName,
    description,
    isPartOf: {
      '@type': 'WebSite',
      name: '51爆料网',
      url: 'http://921xwm.cn/',
    },
  };

  if (datePublished) {
    schema.datePublished = datePublished;
  }

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

export function BreadcrumbListSchema({ items }: {
  items: { name: string; url: string }[];
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

export function ArticleSchema({ headline, url, imageUrl, datePublished, authorName, description }: {
  headline: string;
  url: string;
  imageUrl?: string;
  datePublished: string;
  authorName: string;
  description: string;
}) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    url,
    description,
    datePublished,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: '51爆料网',
    },
  };

  if (imageUrl) {
    schema.image = imageUrl;
  }

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

export function FAQPageSchema({ faqs }: {
  faqs: { question: string; answer: string }[];
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}
